




















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { ValidValues, ValidValuesForSingleTable } from '@/store/models/EnterpriseForm/EnterpriseFormValidValues';
import * as $ from 'jquery';
@Component
export default class SimpleLookup extends Vue {
    isDropdownShown = false;
    @Prop() valueProp?: string;
    @Prop() color?: string;
    @Prop() allowUserEntry?: boolean;
    @Watch('valueProp')
    onValuePropChanged(){
        this.setValueFromProp();
    }
    selectedValue = {} as ValidValues;
    @Prop() validValues?: ValidValues[];
    filteredValues = [] as ValidValues[];
    searchTxt = '';
    @Watch("validValues")
    onValidValuesChanged(newVal: ValidValues[], oldVal: ValidValues[]){
        this.selectedValue = {} as ValidValues;
        if(this.validValues)
            this.filteredValues = this.validValues;
        if(this.valueProp)
            this.setValueFromProp();
    }
    onSearch(){
        if(!this.validValues)return;
        this.filteredValues = this.validValues.filter(v=>v.item2.includes(this.searchTxt));
        if(this.searchTxt === ''){
            this.selectedValue = {} as ValidValues;
            this.$emit('value-cleared');
        }
    }
    created(){
        this.setValueFromProp();
        if(this.validValues)
        this.filteredValues = this.validValues;   
    }
    onFocus(){
        this.searchTxt = '';
        if(this.validValues)
            this.filteredValues = this.validValues;
        $(".tc-dropdown").dropdown({action:'hide',onShow:this.onDropdownShow,onHide: this.onDropdownHide});
    }
    onDropdownShow(){
        this.isDropdownShown = true;
        if(this.selectedValue.item2)
            this.searchTxt = this.selectedValue.item2;
        return true;
    }
    onDropdownHide(){
        this.isDropdownShown = false;
        this.searchTxt = '';
        return true;
    }
    selectValue(value: ValidValues){
        this.selectedValue = value;
        this.$emit('value-selected',value);
    }
    onFocusOut(){
        if(this.allowUserEntry){
            const val  = {} as ValidValues;
            val.item2 = this.searchTxt;
            val.item1 = this.searchTxt;
            this.$emit('value-selected',val)
            this.selectedValue = val;
            return;
        }
        this.searchTxt = '';
        this.isDropdownShown = false;
    }
    setValueFromProp(){
        if(!this.validValues || !this.valueProp )return;
        if(typeof this.valueProp  !== 'string')return;
        let val =  this.validValues.find(item=>item.item2.trim() === (this.valueProp as string).trim() );
        if(val)
            this.selectedValue = val;
        else{
            val = this.validValues.find(item=>item.item1.trim() === (this.valueProp as string).trim() );
            if(val)
                this.selectedValue = val;
        }
    }
}
